<template>
  <div class="ration-info-dialog">
    <div class="title">{{ 'base.additional_info' | translate }}</div>
    <div class="content">
      <div class="info-item">
        <strong>{{ 'base.animal_types' | translate }}:</strong>
        <span>{{ data.group.animal_type.name }}</span>
      </div>
      <div class="info-item">
        <strong>{{ 'sidebar.rations' | translate }}:</strong>
        <ul>
          <li v-for="ration in data.rations" :key="ration.id">{{ ration.name }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RationInfoDialog',

  props: {
    data: {
      type: Object,
    }
  },

  methods: {
    closeDialog () {
      this.$emit('on-close')
    }
  }
}
</script>

<style scoped>
.ration-info-dialog {
  position: relative;
  width: 660px;
  height: auto;
  background: #fff;
  border-radius: 10px;
  padding-top: 26px;
  padding-left: 29px;
  padding-bottom: 10px;
}

.icon {
  position: absolute;
  cursor: pointer;
  right: 15px;
  top: 15px;
}

.title {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 21px;
}

.content {
  font-size: 15px;
}

.info-item {
  margin-bottom: 15px;
}

.info-item strong {
  font-weight: 700;
  display: block;
  margin-bottom: 5px;
}

ul {
  padding-left: 20px;
  list-style-type: disc;
}

li {
  font-size: 15px;
  list-style: circle;
}
</style>
